import React from "react";
import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { Home, ChildCare, EventNote } from "@material-ui/icons";
import { palette } from "../theme";

const NotFoundPage = () => {
  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
      }}
    >
      <Box>
        <Typography
          variant="h1"
          sx={{ fontSize: { xs: "4rem", md: "6rem" }, color: palette.primary }}
        >
          404
        </Typography>
        <Typography variant="h5" sx={{ mb: 1 }}>
          Page not found
        </Typography>
        <Typography variant="body1" sx={{ color: palette.textSecondary, mb: 3 }}>
          Sorry, the page you were looking for doesn't exist.
        </Typography>
        <Box sx={{ display: "flex", gap: 1.5, justifyContent: "center", flexWrap: "wrap" }}>
          <Button component={Link} to="/" variant="contained" color="primary" startIcon={<Home />}>
            Dashboard
          </Button>
          <Button component={Link} to="/kids" variant="outlined" startIcon={<ChildCare />}>
            Kids
          </Button>
          <Button component={Link} to="/sessions" variant="outlined" startIcon={<EventNote />}>
            Sessions
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NotFoundPage;
